import { TextLink } from '@oneaudi/unified-web-components';
import { useCallback, useState } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { MoreInformationTrimlineDialogContent } from '~/app/pages/configurator/components/more-information-dialog/components/more-information-dialog-content';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';
import { CatalogItemType } from '~/graphql/types';

export function MoreInformationTrimline({
	trimline,
	trackSelection,
	step,
	total,
	hasSingleTrimlineAndEngine,
}: {
	trimline: CatalogItemType['trimline'];
	trackSelection?: () => void;
	step: number;
	total: number;
	hasSingleTrimlineAndEngine?: boolean;
}) {
	const { i18n } = useI18n();
	const [open, setOpen] = useState(false);

	const onAddToConfiguration = () => {
		trackSelection && trackSelection();
	};

	const onOpen = useCallback(
		(_open: boolean) => {
			appTrackingService.trackSelectionClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `selections - click to ${_open ? 'open' : 'close'} details layer`,
				label: i18n('ngc.actions.moreInfo'),
				elementName: 'text link',
				value: 'more information',
				category: 'trimline',
				elementCurrentStep: step,
				elementTotalSteps: total,
				item: trimline,
			});
			appTrackingService.viewChangeEvent({
				eventName: _open ? 'configurator - details layer' : 'generic',
				componentName: _open ? 'details-layer' : ' ',
				item: open ? undefined : trimline,
			});
			setOpen(_open);
		},
		[i18n, step, total, trimline, setOpen],
	);

	return (
		<Dialog
			open={open}
			onCloseButtonClick={() => onOpen(false)}
			triggerElement={
				<TextLink variant={'standalone'} size={'sm'} onClick={() => onOpen(true)}>
					{i18n('ngc.actions.moreInfo')}
				</TextLink>
			}>
			{open && (
				<MoreInformationTrimlineDialogContent
					setOpen={setOpen}
					trimline={trimline}
					open={open}
					onAddToConfiguration={onAddToConfiguration}
					hasSingleTrimlineAndEngine={hasSingleTrimlineAndEngine}
				/>
			)}
		</Dialog>
	);
}
